/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RiskIndicatorMetricResults } from './RiskIndicatorMetricResults';
import {
  RiskIndicatorMetricResultsFromJSON,
  RiskIndicatorMetricResultsFromJSONTyped,
  RiskIndicatorMetricResultsToJSON,
} from './RiskIndicatorMetricResults';

/**
 *
 * @export
 * @interface PaginatedRiskIndicatorMetricResultsList
 */
export interface PaginatedRiskIndicatorMetricResultsList {
  /**
   *
   * @type {number}
   * @memberof PaginatedRiskIndicatorMetricResultsList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedRiskIndicatorMetricResultsList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedRiskIndicatorMetricResultsList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<RiskIndicatorMetricResults>}
   * @memberof PaginatedRiskIndicatorMetricResultsList
   */
  results: Array<RiskIndicatorMetricResults>;
}

/**
 * Check if a given object implements the PaginatedRiskIndicatorMetricResultsList interface.
 */
export function instanceOfPaginatedRiskIndicatorMetricResultsList(
  value: object,
): value is PaginatedRiskIndicatorMetricResultsList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedRiskIndicatorMetricResultsListFromJSON(json: any): PaginatedRiskIndicatorMetricResultsList {
  return PaginatedRiskIndicatorMetricResultsListFromJSONTyped(json, false);
}

export function PaginatedRiskIndicatorMetricResultsListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedRiskIndicatorMetricResultsList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(RiskIndicatorMetricResultsFromJSON),
  };
}

export function PaginatedRiskIndicatorMetricResultsListToJSON(
  value?: PaginatedRiskIndicatorMetricResultsList | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(RiskIndicatorMetricResultsToJSON),
  };
}
